import Navigation from "./Navigation";

const Header = (props) => {
  return (
    <header>
      <h1>Krisztian Ivan's Personal Portfolio</h1>
      <Navigation />
    </header>
  );
};

export default Header;
